import { ReactNode } from 'react'

import { useBankPortalContext } from 'bank-portal-context'
import { DropDown } from 'ui/components/DropDown'
import { IconName } from 'ui/components/Icon'

import * as SC from './styles'

type NeedHelpMenuProps = {
  children: ReactNode
}

export const NeedHelpMenu = (props: NeedHelpMenuProps) => {
  const { children } = props

  const { activateZendeskWidget: onHelpClick } = useBankPortalContext()

  return (
    <DropDown menuPosition={'bottom-end'} button={children}>
      <SC.MenuItem to="/release-notes">
        <SC.MenuItemIcon name={IconName.SETTINGS} /> Release Notes
      </SC.MenuItem>
      <SC.MenuItem onClick={onHelpClick}>
        <SC.MenuItemIcon name={IconName.CHAT_BUBBLE_QUESTION} /> Contact Us
      </SC.MenuItem>
    </DropDown>
  )
}
